var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker-info-window"},[_c('marker-info-window-details',{staticClass:"marker-details-container",attrs:{"data-cy":"marker-details","deviceTitle":_vm.itemInfo.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }